module.exports = __webpack_public_path__ + "img/a-2.2a973446.png";